import styled from 'styled-components';
import { breakpoints } from 'config/config';
import '../../../../fonts/AlbertSans/stylesheet.css';

export const StyledPage = styled.div`
  border-radius: 8px;
  margin: 0 auto;
  font-family: ${(props) => props.theme.fontText};
  min-height: 60vh;
  background-color: ${(props) => props.theme.mainBgColor};
  padding-top: 50px;

  &.page-content.no-padding {
    padding-top: 0 !important;
  }

  &.page-content.grey-background {
    background-color: ${(props) => props.theme.greyBackground};
  }

  @media (max-width: ${breakpoints.xs}px) {
    min-height: auto;
  }

  @media (max-width: ${breakpoints.sm}px) {
    &:has(.cart-page-title) {
      border-radius: 15px;
      margin-top: 6px;
    }
  }
`;
